import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SITE_INFO } from '../data';

export default function SEOHead({ title, description }) {
  const location = useLocation();

  useEffect(() => {
    // Standardize title format: "Forsiden" -> "G28 ApS", subpages -> "Subpage Title - G28 ApS"
    const pageTitle = title 
      ? (title.includes(SITE_INFO.name) ? title : `${title} - ${SITE_INFO.name}`)
      : SITE_INFO.name;

    document.title = pageTitle;

    // Meta Description
    const metaDesc = description || SITE_INFO.description;
    let element = document.querySelector('meta[name="description"]');
    if (!element) {
      element = document.createElement('meta');
      element.setAttribute('name', 'description');
      document.head.appendChild(element);
    }
    element.setAttribute('content', metaDesc);

    // Open Graph Title
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', pageTitle);

    // Open Graph Description
    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (!ogDesc) {
      ogDesc = document.createElement('meta');
      ogDesc.setAttribute('property', 'og:description');
      document.head.appendChild(ogDesc);
    }
    ogDesc.setAttribute('content', metaDesc);

  }, [title, description, location]);

  return null;
}
